import { getConfigManager } from '../../config/getConfigManager';
import { Decimal } from '../../datastructures';
import { createAsyncAtom } from '../../lib/state';
import { callApiWithFallbacks } from '../../utils';

const POOL_APRS_ENDPOINT_PATH = '/query/pool_aprs';

export interface PoolData {
  volume: Decimal;
  fee: Decimal;
  swap: number;
  tvl: Decimal;
  baseApr: Decimal;
  rewardApr: Decimal;
  rewardAllocation: Decimal;
}

const poolDataAtom = createAsyncAtom(
  async () => {
    const pools = getConfigManager().getConfig().pools;

    const poolData: Record<string, PoolData> = {};

    Object.entries(pools).forEach(([poolId]) => {
      poolData[poolId] = {
        volume: Decimal.ZERO,
        fee: Decimal.ZERO,
        swap: 0,
        tvl: Decimal.ZERO,
        baseApr: Decimal.ZERO,
        rewardApr: Decimal.ZERO,
        rewardAllocation: Decimal.ZERO,
      };
    });

    try {
      const response = await callApiWithFallbacks(POOL_APRS_ENDPOINT_PATH);

      Object.entries(pools).forEach(([poolId, pool]) => {
        if (response.data[pool.pair.address]) {
          const { volume, fee, swap, tvl, baseApr, rewardApr, rewardAllocation } = response.data[pool.pair.address];

          poolData[poolId] = {
            volume: Decimal.parse(volume, 0),
            fee: Decimal.parse(fee, 0),
            swap,
            tvl: Decimal.parse(tvl, 0),
            baseApr: Decimal.parse(fee, 0).isZero() ? Decimal.ZERO : Decimal.parse(baseApr, 0),
            rewardApr: Decimal.parse(rewardApr, 0),
            rewardAllocation: Decimal.parse(rewardAllocation, 0),
          };
        }
      });
    } catch (e) {
      console.error(e);
    }

    return poolData;
  },
  undefined,
  ['user-refresh'],
);
export default poolDataAtom;
